<template>
  <div>
    <a-row>
      <a-col span="12">
        <a-descriptions
          title="基本信息"
          :column="1"
          class="simiot-descriptions"
        >
          <!-- <a-descriptions-item label="客户ID">
            {{ agent.id }}
          </a-descriptions-item> -->

          <a-descriptions-item label="客户名称">
            {{ agent.name }}
          </a-descriptions-item>

          <a-descriptions-item label="客户来源">
            {{ agent.source }}
          </a-descriptions-item>

          <a-descriptions-item label="所在城市">
            {{ agent.region }}
          </a-descriptions-item>

          <a-descriptions-item label="行业">
            {{ agent.industry_types }}
          </a-descriptions-item>

          <a-descriptions-item label="设备">
            {{ agent.device_types }}
          </a-descriptions-item>

          <a-descriptions-item label="登录账号">
            {{ agent.username }}
          </a-descriptions-item>

          <a-descriptions-item label="联系对象">
            {{ agent.full_name }}
          </a-descriptions-item>

          <a-descriptions-item label="手机号码">
            {{ agent.phone_number }}
          </a-descriptions-item>

          <a-descriptions-item label="联系邮箱">
            {{ agent.email }}
          </a-descriptions-item>

          <a-descriptions-item label="责任销售">
            {{ agent.sale_full_name }}
          </a-descriptions-item>

          <a-descriptions-item label="签约主体">
            {{ agent.contracting_party }}
          </a-descriptions-item>

          <a-descriptions-item label="服务协议">
            <a :href="platformServiceAgreement.resource_url" target="_blank">
              {{ platformServiceAgreement.name }}
            </a>
          </a-descriptions-item>

          <a-descriptions-item label="IP地址">
            {{ agent.ip }}
          </a-descriptions-item>

          <a-descriptions-item label="最近登录时间">
            {{ agent.last_sign_in_at }}
          </a-descriptions-item>

          <a-descriptions-item label="最近登录IP">
            {{ agent.last_sign_in_ip }}
          </a-descriptions-item>

          <a-descriptions-item v-if="canManageLoginLock" label="登录锁定">
            <span v-if="agent.login_locked">锁定中，剩余{{ loginLockMinutes }}分钟</span>
            <span v-else>未锁定</span>
            <a v-if="agent.login_locked" style="margin-left: 12px" @click="clearLoginLock">解除锁定</a>
          </a-descriptions-item>

          <a-descriptions-item label="创建时间">
            {{ agent.created_at }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col span="12">
        <a-descriptions
          title="操作历史"
          :column="1"
          class="simiot-descriptions"
        />

        <operation-history-list
          :reference-id="this.agentId"
          reference-type="Agent"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findAgent, clearAgentLoginLock } from '@/api/agent'
import OperationHistoryList from '@/views/operation_histories'
import { hasPermission } from '@/utils/permission'

export default {
  name: 'ShowAgent',
  components: { OperationHistoryList },
  data() {
    return {
      agent: {},
      platformServiceAgreement: {}
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    },
    canManageLoginLock() {
      return hasPermission('agents/login_lock')
    },
    loginLockMinutes() {
      return Math.max(1, Math.ceil((this.agent.login_lock_remain_seconds || 0) / 60))
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findAgent(this.agentId).then((res) => {
        if (res.code === 0) {
          this.agent = res.data
          this.platformServiceAgreement = res.data.platform_service_agreement
        }
      })
    },

    clearLoginLock() {
      const vm = this
      this.$confirm({
        title: '确定解除该账号的登录锁定吗?',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return clearAgentLoginLock(vm.agentId).then((res) => {
            if (res.code === 0) {
              vm.fetchData()
            }
          })
        }
      })
    }
  }
}
</script>
